import delivaApiService from '../../services/apiService';
import { FETCH_COUNTRIES } from '../types';

export const actionFetchCountries = () => async (dispatch, getState) => {
  // Don't re-fetch if already loaded
  const existing = getState().country.countries;
  if (existing && existing.length > 0) return;

  const response = await delivaApiService('getCountriesWithUnits', {});
  if (response?.data?.status === 200) {
    dispatch({ type: FETCH_COUNTRIES, payload: response.data.resourceData });
  }
};
